// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MessageCreate } from "./MessageCreate";
import {
  MessageCreateFromJSON,
  MessageCreateFromJSONTyped,
  MessageCreateToJSON,
  MessageCreateToJSONTyped,
} from "./MessageCreate";
import type { Creator } from "./Creator";
import {
  CreatorFromJSON,
  CreatorFromJSONTyped,
  CreatorToJSON,
  CreatorToJSONTyped,
} from "./Creator";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 * Comment creation model
 *
 * creator: Optionally when user authorizes with an API key.
 * @export
 * @interface CommentCreate
 */
export interface CommentCreate {
  /**
   *
   */
  messages: Array<MessageCreate>;
  /**
   *
   */
  location: Point;
  /**
   *
   */
  creator?: Creator | null;
  /**
   * Semantic ID to link comments to map in Publication. Now optional for backwards compatibility, but should be provided when possible.
   */
  mapId?: number | null;
}

/**
 * Check if a given object implements the CommentCreate interface.
 */
export function instanceOfCommentCreate(value: object): value is CommentCreate {
  if (!("messages" in value) || value["messages"] === undefined) return false;
  if (!("location" in value) || value["location"] === undefined) return false;
  return true;
}

export function CommentCreateFromJSON(json: any): CommentCreate {
  return CommentCreateFromJSONTyped(json, false);
}

export function CommentCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentCreate {
  if (json == null) {
    return json;
  }
  return {
    messages: (json["messages"] as Array<any>).map(MessageCreateFromJSON),
    location: PointFromJSON(json["location"]),
    creator:
      json["creator"] === undefined
        ? undefined
        : json["creator"] === null
        ? null
        : CreatorFromJSON(json["creator"]),
    mapId:
      json["map_id"] === undefined ? undefined : json["map_id"] === null ? null : json["map_id"],
  };
}

export function CommentCreateToJSON(json: any): CommentCreate {
  return CommentCreateToJSONTyped(json, false);
}

export function CommentCreateToJSONTyped(
  value?: CommentCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    messages: (value["messages"] as Array<any>).map(MessageCreateToJSON),
    location: PointToJSON(value["location"]),
    creator: CreatorToJSON(value["creator"]),
    map_id: value["mapId"],
  };
}
